import dayjs from 'dayjs'
export const formatDate = (date, format = 'YYYY-MM-DD HH:mm:ss') => {
  try {
    const d = new Date(date)
    return dayjs(d).format(format)
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log('parse Date error，source date is ', date)
  }
  return dayjs
}

const unitToSecond = {
  ms: 1 / 1000,
  s: 1,
  m: 60,
  h: 60 * 60,
  d: 60 * 60 * 24,
}
const Renders = ['d', 'h', 'm', 's'] as const

export const formatDuration = (duration: number, unit: keyof typeof unitToSecond = 's') => {
  let second = duration * unitToSecond[unit]
  const [d, ...times] = Renders.map((u) => {
    const num = Math.floor(second / unitToSecond[u])
    second = second % unitToSecond[u]
    return num
  })
  const timeStr = times.map((t) => `${t}`.padStart(2, '0')).join(':')
  if (d) {
    return `${d}d ${timeStr}`
  }
  return timeStr
}

/**
 * 先把时间戳按时区转成字符串“2025-01-01 00:00:00.000”，然后再转成当前时区的时间戳；
 * 因为用户输入的时候看见的是字符串，然后我们按当前时区转成时间戳给后端保存；所以展示的时候需要逆向转换再展示，就能保持用户跨时区看见的字符串没有变化
 * @param time
 * @param timezone
 * @returns
 */
export const formatTimezone = (time: number, timezone: string) => {
  if (time && timezone) {
    const dateStr = dayjs(time).tz(timezone).format('YYYY-MM-DD HH:mm:ss.SSS')
    return dayjs(dateStr).valueOf()
  }
  return time
}
